// src/services/credit.service.js
import api from './api';

const creditService = {
  createAdvancePayment: async (data) => (await api.post('/credits/advance', data)).data,
  voidAdvancePayment:   async (id)   => (await api.post(`/credits/advance/${id}/void`)).data,
  applyCredit:          async (data) => (await api.post('/credits/apply', data)).data,
  getDealerCreditSummary: async (dealerId) => (await api.get(`/credits/dealer/${dealerId}/summary`)).data,
  getAdvancePaymentHistory: async (ownerType, ownerId) => (await api.get('/credits/history', { params: { ownerType, ownerId } })).data,
  getPendingAdvancePayments: async (companyId = null) => {
  const params = {};
  if (companyId) params.companyId = companyId;
  return (await api.get('/credits/advance/pending', { params })).data;
},
confirmAdvancePayment: async (id) => (await api.post(`/credits/advance/${id}/confirm`)).data,
rejectAdvancePayment:  async (id, reason = '') => (await api.post(`/credits/advance/${id}/reject`, { reason })).data,
};
export default creditService;